var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeavingWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.44922L5.87802 10.1386L7.67347 32.1096C7.81703 33.904 9.27688 35.2809 11.0295 35.2752H31.3686C33.041 35.279 34.4598 34.0151 34.6966 32.3145L36.4659 19.7558C36.6636 18.3521 35.7146 17.0499 34.3498 16.8469C34.2305 16.8297 6.50074 16.8201 6.50074 16.8201",
    stroke: "#CAD1D8",
    strokeWidth: 2.87925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9798 25.0616H22.4441C21.6048 25.0616 20.9453 24.3676 20.9453 23.5308C20.9453 22.6735 21.6048 22 22.4441 22H27.9798C28.8192 22 29.4787 22.6735 29.4787 23.5308C29.4787 24.3676 28.8192 25.0616 27.9798 25.0616Z",
    fill: "#CAD1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2096 41.9141C10.7708 41.9141 11.2238 42.3813 11.2238 42.9558C11.2238 43.5323 10.7708 43.9995 10.2096 43.9995C9.64837 43.9995 9.19531 43.5323 9.19531 42.9558C9.19531 42.3813 9.64837 41.9141 10.2096 41.9141Z",
    fill: "#CAD1D8",
    stroke: "#CAD1D8",
    strokeWidth: 2.87925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2408 41.9141C31.802 41.9141 32.2569 42.3813 32.2569 42.9558C32.2569 43.5323 31.802 43.9995 31.2408 43.9995C30.6796 43.9995 30.2266 43.5323 30.2266 42.9558C30.2266 42.3813 30.6796 41.9141 31.2408 41.9141Z",
    fill: "#CAD1D8",
    stroke: "#CAD1D8",
    strokeWidth: 2.87925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.4453,
    cy: 12.5,
    r: 12.5,
    fill: "#FDECEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3759 9.02269C40.6074 9.02269 40.8002 9.21014 40.8002 9.44867V9.6692C40.8002 9.90192 40.6074 10.0952 40.3759 10.0952H30.5109C30.2787 10.0952 30.0859 9.90192 30.0859 9.6692V9.44867C30.0859 9.21014 30.2787 9.02269 30.5109 9.02269H32.2464C32.5989 9.02269 32.9058 8.77837 32.9851 8.43364L33.076 8.03784C33.2172 7.4987 33.6821 7.14062 34.2141 7.14062H36.6721C37.1983 7.14062 37.6684 7.4987 37.8044 8.00941L37.9017 8.43306C37.9804 8.77837 38.2872 9.02269 38.6403 9.02269H40.3759ZM39.4866 17.0849C39.6678 15.4384 39.985 11.5269 39.985 11.4874C39.9966 11.3679 39.9567 11.2547 39.8774 11.1636C39.7923 11.0783 39.6846 11.0278 39.5659 11.0278H31.3096C31.1904 11.0278 31.0769 11.0783 30.9982 11.1636C30.9183 11.2547 30.8789 11.3679 30.8847 11.4874C30.8858 11.4947 30.8972 11.6324 30.9162 11.8628C31.0007 12.8861 31.2362 15.7362 31.3884 17.0849C31.496 18.0784 32.1647 18.7029 33.1332 18.7255C33.8805 18.7423 34.6505 18.7481 35.4378 18.7481C36.1794 18.7481 36.9325 18.7423 37.703 18.7255C38.7051 18.7087 39.3731 18.0952 39.4866 17.0849Z",
    fill: "#F65164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavingWarning);
export default __webpack_public_path__ + "static/media/leavingWarning.e735717e9ce5adbd17079b98fbfab500.svg";
export { ForwardRef as ReactComponent };